import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { MaterialSchema } from '$/services/usecases/materials/mapper/materials';

export const HarmonySchema = z.object({
  id: z.string(),
  name: z.string(),
  position: z.number(),
  scene: z.enum(['interior', 'exterior']),
  mood: z.string(),
  tonality: z.string(),
  colorRange: z.string(),
  sceneType: z.string(),
  inspirationId: z.string(),
  materials: z.tuple([MaterialSchema, MaterialSchema, MaterialSchema]),
  inspirationMaterials: z.record(z.string(), z.optional(z.string())),
});

export type Harmony = z.infer<typeof HarmonySchema>;

export const HarmonyWithMaterialsSchema = z.extend(HarmonySchema, {
  inspirationMaterials: z.record(z.string(), z.optional(MaterialSchema)),
});

export type HarmonyWithMaterials = z.infer<typeof HarmonyWithMaterialsSchema>;

export const GetHarmoniesResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(HarmonySchema),
});

export const GetHarmonyByIdResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(HarmonyWithMaterialsSchema),
});
